import { showConfirmation } from '../lib/confirmation';
import { formatPhone, formatName, formatEmail } from '../lib/format';
import PageContent from '../components/ui/PageContent';
import PageHeader from '../components/ui/PageHeader';
import { Table, TableRow, TableCell, TableHead, TableHeaderCell } from '../components/ui/Table';
import FieldLabel from '../components/ui/FieldLabel';
import UiInput from '../components/ui/Input';
import UiCheckbox from '../components/ui/Checkbox';
import Button from '../components/ui/Button';
import { useState, useEffect } from 'react';
import Input from '../components/Input';
import Dropdown from '../components/Dropdown';
import { checkEmailInValid, getDropdownValue, postWithAuth, randomString } from '../common';
import { googleApiKey } from '../constants';
import { useSelector } from 'react-redux';
import Header from "../components/Header";
import AutoComplete from "react-google-autocomplete";
import Sidebar from '../components/Sidebar';
import Section from '../components/Section';
import { toast } from 'react-toastify';
import MyDropzone from '../components/MyDropzone';
import { EditIcon, ResetIcon, TrashIcon } from '../components/NavIcons';
import { useLocation, useSearchParams } from 'react-router-dom';
import ModalComponent from '../components/Modal';
import CompactSuccessModal from '../components/CompactSuccessModal';
import LoadingPopup from '../components/LoadingPopup';
const CompanyProfile = () => {
    const location = useLocation()
    const [searchParams] = useSearchParams()

    const userInfo = useSelector((state) => state.user.user)
    const activeOrg = useSelector((state) => state.user.activeOrg)
    const activeOrgInfo = useSelector((state) => state.user.activeOrgInfo)

    const [loading, setLoading] = useState(false)
    const [editing, setEditing] = useState(false)
    const [companyName, setCompanyName] = useState('')
    const [abn, setAbn] = useState('')
    const [address, setAddress] = useState('')
    const [coordinates, setCoordinates] = useState([])
    const [contactNo, setContactNo] = useState('')
    const [notificationContactNo, setNotificationContactNo] = useState('')

    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [invoiceEmail, setInvoiceEmail] = useState('')
    const [weeklyTasksSummaryEmailEnabled, setWeeklyTasksSummaryEmailEnabled] = useState(true)
    const [incompleteAllocationsEmailEnabled, setIncompleteAllocationsEmailEnabled] = useState(true)
    const [logo, setLogo] = useState('')
    const [uploading, setUploading] = useState(false)
    // The address field is uncontrolled (Google autocomplete); remount it whenever
    // the saved details are (re)loaded so it shows them, e.g. after Cancel.
    const [addressInputKey, setAddressInputKey] = useState(0)

    const [accountName, setAccountName] = useState('')
    const [bankName, setBankName] = useState('')
    const [bsb, setBsb] = useState('')
    const [accountNumber, setAccountNumber] = useState('')

    const [abnNameOptions, setAbnNameOptions] = useState([])
    const [entityNameApi, setEntityNameApi] = useState('')
    const [orgAdmins, setOrgAdmins] = useState([])
    const [adminFirstName, setAdminFirstName] = useState('')
    const [adminLastName, setAdminLastName] = useState('')
    const [adminEmail, setAdminEmail] = useState('')
    const [adminContactNo, setAdminContactNo] = useState('')
    const [adminUserType, setAdminUserType] = useState('staff')
    const [adminLoading, setAdminLoading] = useState(false)
    const [adminSaving, setAdminSaving] = useState(false)
    const [showAddUserModal, setShowAddUserModal] = useState(false)
    const [viewingOrgUser, setViewingOrgUser] = useState(null)
    const [companySuccessMessage, setCompanySuccessMessage] = useState(null)
    const [userPendingDelete, setUserPendingDelete] = useState(null)

    useEffect(() => {
        if (activeOrgInfo) {
            setInformation()
        }
    }, [activeOrgInfo])

    useEffect(() => {
        if (activeOrg?.id && activeOrg.role === 'admin') {
            fetchOrgAdmins()
        }
    }, [activeOrg])


    const setInformation = () => {
        setCompanyName(activeOrgInfo.name || '')
        setAbn(activeOrgInfo.abn || '')
        setAddress(activeOrgInfo.address || '')
        setAddressInputKey(key => key + 1)
        setCoordinates(activeOrgInfo.coordinates || [])
        setContactNo(activeOrgInfo.contactNo || '')
        setNotificationContactNo(activeOrgInfo.notificationContactNo || '')
        setFirstName(activeOrgInfo.primaryFirstName || '')
        setLastName(activeOrgInfo.primaryLastName || '')
        setEmail(activeOrgInfo.primaryEmail || '')
        setInvoiceEmail(activeOrgInfo.invoiceEmail || '')
        setWeeklyTasksSummaryEmailEnabled(activeOrgInfo.weeklyTasksSummaryEmailEnabled !== false)
        setIncompleteAllocationsEmailEnabled(activeOrgInfo.incompleteAllocationsEmailEnabled !== false)
        setLogo(activeOrgInfo.logo || '')
        setAccountName(activeOrgInfo.accountName || '')
        setBankName(activeOrgInfo.bankName || '')
        setBsb(activeOrgInfo.bsb || '')
        setAccountNumber(activeOrgInfo.accountNumber || '')
    }


    const handleAbnLookup = async () => {
        try {

            const resp = await postWithAuth('lookupAbn', { abn })

            if (resp && resp.err) {
                toast.error('Error looking up ABN')
                return
            }

            if (resp && resp.data) {
                setEntityNameApi(resp.data.entityName)
                setAbnNameOptions(resp.data.options.map(r => ({ label: r, value: r })))
            }
        } catch (e) {
            toast.error(e.message)
        }
    }

    const handleSaveBusinessInfo = async () => {

        try {
            setLoading(true)

            await postWithAuth('saveBusinessInfo', {
                name: companyName,
                abn,
                address,
                coordinates,
                contactNo,
                notificationContactNo,
                logo,
                primaryFirstName: firstName,
                primaryLastName: lastName,
                primaryEmail: email,
                invoiceEmail,
                weeklyTasksSummaryEmailEnabled,
                incompleteAllocationsEmailEnabled,
                accountName, bankName, bsb, accountNumber,
                orgId: activeOrg.id,
            })


            window.location.reload()
            setLoading(false)

        } catch (e) {
            toast.error(e.message)
            setLoading(false)
        }

    }

    const fetchOrgAdmins = async () => {
        try {
            setAdminLoading(true)
            const resp = await postWithAuth('fetchOrgAdminUsers', { orgId: activeOrg.id })
            if (resp && resp.data) {
                setOrgAdmins(resp.data)
            }
        } catch (e) {
            toast.error(e.message)
        } finally {
            setAdminLoading(false)
        }
    }

    const handleAddOrgAdmin = async () => {
        try {
            if (!adminFirstName || !adminLastName || !adminEmail) {
                toast.error('Please fill in all fields.')
                return
            }
            if (checkEmailInValid(adminEmail)) {
                toast.error('Please enter a valid email.')
                return
            }

            setAdminSaving(true)
            const savedUserName = `${adminFirstName} ${adminLastName}`.trim()
            await postWithAuth('createOrgAdminUser', {
                firstName: adminFirstName,
                lastName: adminLastName,
                email: adminEmail,
                contactNo: adminContactNo,
                userType: adminUserType,
                orgId: activeOrg.id,
            })
            setAdminFirstName('')
            setAdminLastName('')
            setAdminEmail('')
            setAdminContactNo('')
            setAdminUserType('staff')
            setShowAddUserModal(false)
            await fetchOrgAdmins()
            setCompanySuccessMessage({
                title: 'User saved',
                message: `${savedUserName} was added successfully.`,
            })
        } catch (e) {
            toast.error(e.message)
        } finally {
            setAdminSaving(false)
        }
    }

    const handleResetUserPassword = async (user) => {
        if (!user?.email) return
        try {
            await postWithAuth('sendResetPasswordEmail', { email: user.email })
            showConfirmation('Password reset email sent.')
        } catch (e) {
            toast.error(e.message)
        }
    }

    const handleSaveOrgUser = async () => {
        if (!viewingOrgUser?.id || !viewingOrgUser.firstName || !viewingOrgUser.lastName || !viewingOrgUser.email) return
        try {
            setAdminSaving(true)
            const resp = await postWithAuth('updateOrgUser', {
                id: viewingOrgUser.id,
                orgId: activeOrg.id,
                firstName: viewingOrgUser.firstName,
                lastName: viewingOrgUser.lastName,
                email: viewingOrgUser.email,
                contactNo: viewingOrgUser.contactNo || '',
                status: viewingOrgUser.status || 'Active',
                userType: viewingOrgUser.isStaff ? 'staff' : 'owner',
            })
            if (resp?.err) {
                toast.error(resp.err)
                return
            }
            const savedName = formatName(`${viewingOrgUser.firstName} ${viewingOrgUser.lastName}`).trim()
            await fetchOrgAdmins()
            setViewingOrgUser(null)
            setCompanySuccessMessage({
                title: 'User saved',
                message: `${savedName} was updated successfully.`,
            })
        } catch (e) {
            toast.error(e.message)
        } finally {
            setAdminSaving(false)
        }
    }

    const handleDeleteOrgAdmin = async (user) => {
        if (!user?.id) return
        try {
            setAdminLoading(true)
            await postWithAuth('deleteOrgStaffUser', { id: user.id, orgId: activeOrg.id })
            await fetchOrgAdmins()
            setUserPendingDelete(null)
        } catch (e) {
            toast.error(e.message)
        } finally {
            setAdminLoading(false)
        }
    }

    const activeMembership = userInfo?.organisations?.find(organisation => (
        organisation.id === activeOrg?.id || organisation.orgId === activeOrg?.id
    ))
    const currentRole = String(activeOrg?.role || activeMembership?.role || userInfo?.organisations?.[0]?.role || '').toLowerCase()
    const isWorker = location.pathname.startsWith('/worker/') || searchParams.get('view') === 'worker'
    const canEditCompanyProfile = !isWorker && currentRole === 'admin'
    // An admin cannot change their own status or type (the server rejects it).
    const editingOwnUser = !!viewingOrgUser?.id && viewingOrgUser.id === userInfo?.id

    return (<div>
        <Header />
        <LoadingPopup visible={loading || adminLoading} message="Loading..." />
        <div className='pageShell'>
            <Sidebar />
            <PageContent as="div" className={`pageContent pageContentPadded companyPageContent ${editing ? '' : 'companyProfileViewCard'}`}>
                <PageHeader title={<>Company Profile</>} subtitle={<>{isWorker ? 'Company details and contact information' : 'Company details, contacts, accounts and users'}</>} actions={<>{canEditCompanyProfile && <div className='companyProfileHeaderActions'>
                        {editing && canEditCompanyProfile ? <>
                            <Button data-action-tone="cancel" variant="secondary" size="md"  className='secondaryButton companyTopActionButton' onClick={() => { setEditing(false); setInformation() }}>Cancel</Button>
                            <Button data-action-tone="save" variant="soft" size="md"  className='companyTopActionButton saveWithIcon' disabled={!abn || !companyName || !address?.trim() || !contactNo || !bankName || !accountName || !bsb || !accountNumber || loading || uploading} onClick={handleSaveBusinessInfo}>Save</Button>
                        </> : <>

                            {canEditCompanyProfile && <Button data-action-tone="edit" variant="secondary" size="md"  className='companyTopActionButton actionWithIcon' onClick={() => setEditing(true)}><EditIcon />Edit</Button>}
                        </>}
                    </div>}</>} />
                <CompactSuccessModal success={companySuccessMessage} setSuccess={setCompanySuccessMessage} />
                <ModalComponent
                    showModal={!!userPendingDelete}
                    setShowModal={(open) => { if (!open) setUserPendingDelete(null) }}
                    customMaxWidth='300px'
                    customContentStyle={{ minWidth: 0, width: 'min(300px, calc(100vw - 32px))', padding: 0, overflow: 'hidden' }}
                >
                    <div className='companyUserWarningDialog'>
                        <h2>Are you sure?</h2>
                        <p>This will permanently remove {formatName(userPendingDelete?.firstName)} {formatName(userPendingDelete?.lastName)}.</p>
                        <div>
                            <Button data-action-tone="cancel" variant="secondary" size="md"  type='button' className='secondaryButton' onClick={() => setUserPendingDelete(null)}>Cancel</Button>
                            <Button variant="danger" size="md" type='button' className='modalDangerButton' onClick={() => handleDeleteOrgAdmin(userPendingDelete)}>Yes</Button>
                        </div>
                    </div>
                </ModalComponent>
                <ModalComponent
                    showModal={showAddUserModal}
                    setShowModal={setShowAddUserModal}
                    customMaxWidth='340px'
                    customContentStyle={{ minWidth: 0, width: 'min(340px, calc(100vw - 24px))', padding: 0, overflow: 'hidden' }}
                >
                    <div className='companyUserDialog companyAddUserDialog'>
                        <h2>Add User</h2>
                        <div className='companyUserDialogBody'>
                            <Input disabled={adminSaving} value={adminFirstName} setValue={setAdminFirstName} placeholder={'First Name'} label={'First Name'} required />
                            <Input disabled={adminSaving} value={adminLastName} setValue={setAdminLastName} placeholder={'Last Name'} label={'Last Name'} required />
                            <Input disabled={adminSaving} value={adminEmail} setValue={setAdminEmail} placeholder={'Email'} label={'Email'} required />
                            <Input disabled={adminSaving} value={adminContactNo} setValue={setAdminContactNo} placeholder={'+61'} label={'Contact Number'} />
                            <Dropdown
                                disabled={adminSaving}
                                label={'User Type'}
                                required
                                options={[
                                    { label: 'Owner', value: 'owner' },
                                    { label: 'Staff', value: 'staff' },
                                ]}
                                value={getDropdownValue(adminUserType, [
                                    { label: 'Owner', value: 'owner' },
                                    { label: 'Staff', value: 'staff' },
                                ])}
                                setValue={(option) => setAdminUserType(option.value)}
                            />
                        </div>
                        <div className='companyUserDialogFooter'>
                            <Button variant="secondary" size="md" className='secondaryButton' type='button' onClick={() => setShowAddUserModal(false)}>Cancel</Button>
                            <Button variant="create" size="md" type='button' disabled={adminSaving || !adminFirstName || !adminLastName || !adminEmail} onClick={handleAddOrgAdmin}>+ Add User</Button>
                        </div>
                    </div>
                </ModalComponent>
                <ModalComponent
                    showModal={!!viewingOrgUser}
                    setShowModal={(open) => { if (!open) setViewingOrgUser(null) }}
                    customMaxWidth='400px'
                    customContentStyle={{ minWidth: 0, width: 'min(400px, calc(100vw - 24px))', padding: 0, overflow: 'hidden' }}
                >
                    <div className='companyUserDialog companyEditUserDialog'>
                        <div className='companyEditUserDialogHeader'>
                            <h2>Edit User</h2>
                            <div className='companyEditUserHeaderActions'>
                                <Button variant="secondary" size="md" type='button' className='secondaryButton' onClick={() => setViewingOrgUser(null)}>Cancel</Button>
                                <Button data-action-tone="save" variant="soft" size="md"  type='button' className='saveWithIcon' disabled={adminSaving || !viewingOrgUser?.firstName || !viewingOrgUser?.lastName || !viewingOrgUser?.email} onClick={handleSaveOrgUser}>Save</Button>
                            </div>
                        </div>
                        <div className='companyUserDialogBody'>
                            <Input disabled={adminSaving} value={viewingOrgUser?.firstName || ''} setValue={(value) => setViewingOrgUser((user) => ({ ...user, firstName: value }))} label='First Name' required />
                            <Input disabled={adminSaving} value={viewingOrgUser?.lastName || ''} setValue={(value) => setViewingOrgUser((user) => ({ ...user, lastName: value }))} label='Last Name' required />
                            <Input disabled={adminSaving} value={viewingOrgUser?.email || ''} setValue={(value) => setViewingOrgUser((user) => ({ ...user, email: value }))} label='Email' required />
                            <Input disabled={adminSaving} value={viewingOrgUser?.contactNo || ''} setValue={(value) => setViewingOrgUser((user) => ({ ...user, contactNo: value }))} label='Contact Number' />
                            <Dropdown
                                disabled={adminSaving || editingOwnUser}
                                label='User Type'
                                options={[{ label: 'Owner', value: 'owner' }, { label: 'Staff', value: 'staff' }]}
                                value={getDropdownValue(viewingOrgUser?.isStaff ? 'staff' : 'owner', [{ label: 'Owner', value: 'owner' }, { label: 'Staff', value: 'staff' }])}
                                setValue={(option) => setViewingOrgUser((user) => ({ ...user, isStaff: option.value === 'staff' }))}
                            />
                            <Dropdown
                                disabled={adminSaving || editingOwnUser}
                                label='Status'
                                options={[{ label: 'Active', value: 'Active' }, { label: 'Inactive', value: 'Inactive' }]}
                                value={getDropdownValue(viewingOrgUser?.status || 'Active', [{ label: 'Active', value: 'Active' }, { label: 'Inactive', value: 'Inactive' }])}
                                setValue={(option) => setViewingOrgUser((user) => ({ ...user, status: option.value }))}
                            />
                        </div>
                        <div className='companyUserDialogFooter'>
                            <Button variant="secondary" size="md" type='button' className='companyEditUserResetButton' disabled={adminSaving} onClick={() => handleResetUserPassword(viewingOrgUser)}><ResetIcon />Reset Password</Button>
                        </div>
                    </div>
                </ModalComponent>
                {isWorker ? (
                    <div className='companyProfileSectionStack'>
                        <Section title={'Company Details'} className='width-100 companyProfileCard' variant='card'>
                            <Table emptyItems="company details" className='companyProfileTable workerCompanyDetailsTable'>
                                <tbody>
                                    <TableRow><TableCell><strong>Company Name</strong></TableCell><TableCell>{activeOrgInfo?.name || '-'}</TableCell></TableRow>
                                    <TableRow><TableCell><strong>ABN</strong></TableCell><TableCell>{activeOrgInfo?.abn || '-'}</TableCell></TableRow>
                                    <TableRow><TableCell><strong>Address</strong></TableCell><TableCell>{activeOrgInfo?.address || '-'}</TableCell></TableRow>
                                    <TableRow><TableCell><strong>Contact Number</strong></TableCell><TableCell>{formatPhone(activeOrgInfo?.contactNo || '-')}</TableCell></TableRow>
                                    <TableRow><TableCell><strong>Primary Contact First Name</strong></TableCell><TableCell>{formatName(activeOrgInfo?.primaryFirstName || '-')}</TableCell></TableRow>
                                    <TableRow><TableCell><strong>Primary Contact Last Name</strong></TableCell><TableCell>{formatName(activeOrgInfo?.primaryLastName || '-')}</TableCell></TableRow>
                                    <TableRow><TableCell><strong>Primary Contact Email</strong></TableCell><TableCell>{formatEmail(activeOrgInfo?.primaryEmail || '-')}</TableCell></TableRow>
                                </tbody>
                            </Table>
                        </Section>
                    </div>
                ) : <>
                <div className='companyProfileSectionStack'>
                    <div className='companyProfileTopRow'>
                    <Section title={'Business Details'} className='companyProfileCard companyBusinessDetailsCard' variant='card'>
                        <div className='companyProfileFieldGrid'>
                        {!editing && <Input disabled={!editing} value={companyName} setValue={setCompanyName} placeholder={'Company Name'} label={'Company Name'} required />}
                        <Input disabled={!editing} value={abn} setValue={setAbn} label={'ABN'} required />
                        {editing && <Button variant="secondary" size="md" disabled={!abn || abn.trim().length !== 11} className='companyInlineButton' onClick={handleAbnLookup}>Verify ABN</Button>}
                        {editing && <Dropdown label={'Name'} disabled={abnNameOptions.length === 0} required options={abnNameOptions} value={getDropdownValue(companyName, abnNameOptions)} setValue={v => setCompanyName(v.value)} />}

                        <div className='companyProfileFieldSpanFull'>
                            <FieldLabel className="fieldLabel">Address <span className='requiredMark'>*</span></FieldLabel>
                            <UiInput as={AutoComplete}
                                key={addressInputKey}
                                disabled={!editing}
                                apiKey={googleApiKey}
                                options={{
                                    types: ["address"],
                                    componentRestrictions: { country: "au" },
                                }}
                                defaultValue={address}
                                // Typed text is kept even when no suggestion is picked.
                                onChange={(event) => setAddress(event.target.value)}
                                onPlaceSelected={(place) => { setCoordinates([place.geometry.location.lat(), place.geometry.location.lng()]); setAddress(place.formatted_address); }}
                                className='companyAutocompleteField'
                            />
                        </div>
                        <Input disabled={!editing} value={contactNo} setValue={setContactNo} placeholder={'+61'} label={'Contact Number'} required />
                        <div className='companyProfileFieldSpanFull'>
                            <MyDropzone setUploading={setUploading} disabled={!editing} storageLocation={`Business/${randomString()}`} label={'Business Logo'} customMessage={'Click here/Drop files here to upload'} editing={true} errors={[]} name={'document'} image={logo} updateImage={(doc) => setLogo(doc)} />
                        </div>
                        </div>
                    </Section>

                    <Section title={'Company Contact'} className='companyProfileCard companyContactCard' variant='card'>
                        <div className='companyProfileFieldGrid'>
                        <Input disabled={!editing} value={firstName} setValue={setFirstName} placeholder={'First Name'} label={'First Name'} required />
                        <Input disabled={!editing} value={lastName} setValue={setLastName} placeholder={'Last Name'} label={'Last Name'} required />
                        <Input disabled={!editing} value={email} setValue={setEmail} placeholder={'Email'} label={'Email'} required />
                        <div className='companyContactNotificationField'>
                            <Input disabled={!editing} value={notificationContactNo} setValue={setNotificationContactNo} placeholder={'+61..., +61...'} label={'Notification Contact Number(s)'} />
                        </div>
                        </div>
                    </Section>
                    </div>

                    <div className='companyProfileTopRow'>
                    <Section title={'Invoice Email'} className='companyProfileCard' variant='card'>
                        <div className='companyProfileFieldGrid'>
                        <Input disabled={!editing} value={invoiceEmail} setValue={setInvoiceEmail} placeholder={'Email'} label={'Invoice Email'} />
                        </div>
                    </Section>
                    <Section title={'Email Notifications'} className='companyProfileCard' variant='card'>
                        <FieldLabel choice className='fieldLabel'><UiCheckbox type='checkbox' disabled={!editing} checked={weeklyTasksSummaryEmailEnabled} onChange={event => setWeeklyTasksSummaryEmailEnabled(event.target.checked)} /> Weekly tasks summary</FieldLabel>
                        <FieldLabel choice className='fieldLabel'><UiCheckbox type='checkbox' disabled={!editing} checked={incompleteAllocationsEmailEnabled} onChange={event => setIncompleteAllocationsEmailEnabled(event.target.checked)} /> Incomplete allocations reminder</FieldLabel>
                    </Section>

                    <Section title={'Accounts'} className='companyProfileCard companyAccountsCard' variant='card'>
                        <div className='companyProfileFieldGrid'>
                        <Input disabled={!editing} value={bankName} setValue={setBankName} placeholder={'Bank Name'} label={'Bank Name'} required />
                        <Input disabled={!editing} value={accountName} setValue={setAccountName} placeholder={'Account Name'} label={'Account Name'} required />
                        <Input disabled={!editing} value={bsb} setValue={setBsb} placeholder={'BSB'} label={'BSB'} required />
                        <Input disabled={!editing} value={accountNumber} setValue={setAccountNumber} placeholder={'Account Number'} label={'Account Number'} required />
                        </div>
                    </Section>
                    </div>

                    {canEditCompanyProfile && <Section title={'Users'} className='width-100 companyProfileCard companyUsersCard' variant='card' action={<Button variant="create" size="md" className='companyAddUserButton' type='button' onClick={() => setShowAddUserModal(true)}>+ User</Button>}>

                        <div className='companyProfileTableWrap'>
                            {adminLoading ? <p>Loading...</p> : (
                                orgAdmins.length === 0 ? <p>No admin users yet.</p> : (
                                    <Table emptyItems="users" className='companyProfileTable'>
                                        <TableHead>
                                            <TableRow>
                                                <TableHeaderCell>Name</TableHeaderCell>
                                                <TableHeaderCell>Email</TableHeaderCell>
                                                <TableHeaderCell>Contact Number</TableHeaderCell>
                                                <TableHeaderCell>Status</TableHeaderCell>
                                                <TableHeaderCell>Type</TableHeaderCell>
                                                <TableHeaderCell>Action</TableHeaderCell>
                                            </TableRow>
                                        </TableHead>
                                        <tbody>
                                            {orgAdmins.map(user => {
                                                const canDelete = user.isStaff && user.id !== userInfo?.id
                                                return (
                                                    <TableRow key={user.id}>
                                                        <TableCell>{formatName(user.firstName)} {formatName(user.lastName)}</TableCell>
                                                        <TableCell>{formatEmail(user.email)}</TableCell>
                                                        <TableCell>{formatPhone(user.contactNo || '—')}</TableCell>
                                                        <TableCell>{user.status || 'Active'}</TableCell>
                                                        <TableCell>{user.isStaff ? 'Staff' : 'Owner'}</TableCell>
                                                        <TableCell className='companyUserActions'>
                                                            <Button data-action-tone="edit" variant="secondary" size="icon"  type='button' title='Edit user' aria-label='Edit user' onClick={() => setViewingOrgUser(user)}><EditIcon /></Button>
                                                            {canDelete && (
                                                                <Button data-action-tone="delete" variant="danger" size="icon"  type='button' title='Delete user' aria-label='Delete user' className='companyUserDeleteAction' onClick={() => setUserPendingDelete(user)}><TrashIcon /></Button>
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })}
                                        </tbody>
                                    </Table>
                                )
                            )}
                        </div>
                    </Section>}
                </div>
                </>}
            </PageContent>
        </div>
    </div>)
}

export default CompanyProfile
